export const const_web3DialogClosedByUser = 'Modal closed by user';
